import { render } from "./FloatingNewTaskBtn.vue?vue&type=template&id=0264bbd0"
import script from "./FloatingNewTaskBtn.vue?vue&type=script&lang=js"
export * from "./FloatingNewTaskBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__